"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FilterValue } from "@/shared/types/type/search";
import { TreatmentSearchList } from "@/features/search/ui";
import { useTranslations } from "next-intl";
interface TreatmentSearchProps {
  treatmentList: FilterValue[];
}
const ITEMS_PER_PAGE = 10;
const TreatmentSearch = t0 => {
  const $ = _c(13);
  const {
    treatmentList
  } = t0;
  const t = useTranslations();
  let pages;
  if ($[0] !== treatmentList) {
    pages = [];
    for (let i = 0; i < treatmentList.length; i = i + ITEMS_PER_PAGE, i) {
      pages.push(treatmentList.slice(i, i + ITEMS_PER_PAGE));
    }
    $[0] = treatmentList;
    $[1] = pages;
  } else {
    pages = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("treatmentSearch.title");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <Typography size={16} lineHeight={24} className="text-gray-900 font-bold pb-4">{t1}</Typography>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [Pagination];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      clickable: false
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== pages) {
    t5 = <Swiper modules={t3} spaceBetween={16} slidesPerView={1} pagination={t4} className="treatment-search-swiper">{pages.map(_temp)}</Swiper>;
    $[8] = pages;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <section className="bg-white px-4 pt-6">{t2}{t5}</section>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default TreatmentSearch;
function _temp(page, index) {
  return <SwiperSlide key={`treatment-search-page-${index}`}><div className="grid grid-cols-5 gap-4 justify-items-center"><TreatmentSearchList treatmentList={page} /></div></SwiperSlide>;
}